import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=b0fdd164&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=b0fdd164&prod&scoped=true&lang=css"
import style1 from "./UserCenter.vue?vue&type=style&index=1&id=b0fdd164&prod&lang=less&scoped=true"
import style2 from "./UserCenter.vue?vue&type=style&index=2&id=b0fdd164&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdd164",
  null
  
)

export default component.exports